// extracted by mini-css-extract-plugin
export var projectList = "projects-module--projectList--I53gZ";
export var projectCard = "projects-module--projectCard--3pFyD";
export var projectCardImage = "projects-module--projectCardImage--1FDNH";
export var projectCardBg = "projects-module--projectCardBg--3RUUN";
export var projectCardMeta = "projects-module--projectCardMeta--3HSCF";
export var projectCardTitle = "projects-module--projectCardTitle--70W_H";
export var projectCardCTA = "projects-module--projectCardCTA--KO-ZN";
export var projectCardCTAContainer = "projects-module--projectCardCTAContainer--1hocb";